import React from 'react';
import { Grid, Box } from '@material-ui/core';

const BranchViewDetailsHeader = ({ styles, data }) => {
  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={8}>
          <Box
            fontSize={24}
            fontWeight={500}
            fontFamily={'Rubik'}
            mt={1}
            mb={2}>
            {data ? (
              <Box display="flex" flexDirection="row">
                {data.schoolName}
              </Box>
            ) : (
              'View Branch Details'
            )}
          </Box>
          <div className={styles.subHeadingText}>
            Update your branch information
          </div>
        </Grid>
        <Grid item xs={4}>
          <div style={{ float: 'right' }}>
            {/* <Button
              component={Link}
              // to={'/'}
              variant="contained"
              disableElevation
              size="large"
              color="primary">
              Add Leads
            </Button> */}
          </div>
        </Grid>
      </Grid>
      <Box
        mt={6}
        mb={2}
        fontFamily="Rubik"
        display="flex"
        justifyContent="space-between">
        <Box>
          <Box fontSize={18} fontWeight={'fontWeightMedium'} mb={1}>
            Your School Information
          </Box>
          <Box maxWidth={640} fontSize={14}>
            Fill up the information about your school that parents would be able
            to see on Buzzapp’s Admission App.
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default BranchViewDetailsHeader;
